import { render, staticRenderFns } from "./GuestAccessHistoryClient.vue?vue&type=template&id=1ebaf948&scoped=true"
import script from "./GuestAccessHistoryClient.vue?vue&type=script&lang=js"
export * from "./GuestAccessHistoryClient.vue?vue&type=script&lang=js"
import style0 from "./GuestAccessHistoryClient.vue?vue&type=style&index=0&id=1ebaf948&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1ebaf948",
  null
  
)

export default component.exports